import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/layout'

// 管理后台
import manageOrderManageRouter from './manage/orderManage'
import financeManageRouter from './manage/financeManage'
import employeeManageRouter from './manage/employeeManage'
import manageAgentManageRouter from './manage/agentManage'
import systemManageRouter from './manage/systemManage'
import channelManage from './manage/channelManage'
import merchantOrderManageRouter from './manage/merchantAccountManage'
import statisticsManageRouter from './manage/statisticsManage'

// 代理后台
import agentManageRouter from './agent/agentManage'
import orderManageRouter from './agent/orderManage'
import merchantManageRouter from './agent/merchantManage'
import orderStatisticsManageRouter from './agent/orderStatisticsManage'

// 商户后台
import merchantInfoRouter from './merchant/merchantInfo'
import merchantSysSetting from './merchant/merchantSysSetting'
import merchantOrderCheckRouter from './merchant/merchantOrderCheck'
import merchantSubAccounRouter from './merchant/subAccounManage'
import merchantTransferRouter from './merchant/transferManage'

export const constantRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: 'home',
    meta: { title: '我的首页', icon: 'menu-home', roles: ['all'] },
    children: [
      {
        path: 'home',
        component: () => {
          if (Vue.prototype.MerchantHost.indexOf(document.domain) > -1) {
            return import('@/views/merchant/home/home')
          } else if (Vue.prototype.ManageHost.indexOf(document.domain) > -1) {
            return import('@/views/manage/home/home')
          } else if (Vue.prototype.AgentHost.indexOf(document.domain) > -1) {
            return import('@/views/agent/home/home')
          }
        },
        name: 'Home',
        hidden: true,
        meta: { title: '我的首页', icon: 'menu-home', noCache: false }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    hidden: true
  },
  {
    path: '/reset/:typeId',
    component: () => import('@/views/common/resetPassword'),
    name: 'reset',
    hidden: true
  },
  {
    path: '/recharge/:id',
    component: () => import('@/views/merchant/recharge/recharge'),
    name: 'recharge',
    hidden: true
  }
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const adminRouterMap = [
  // {
  //   path: '/modifyPassword',
  //   component: Layout,
  //   meta: { title: '密码管理', roles: ['all'] },
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/common/resetPassword'),
  //       name: 'modifyPassword',
  //       meta: { title: '修改密码', icon: 'password', noCache: true }
  //     }
  //   ]
  // },
  manageOrderManageRouter,
  statisticsManageRouter,
  merchantOrderManageRouter,
  channelManage,
  financeManageRouter,
  employeeManageRouter,
  manageAgentManageRouter,
  systemManageRouter
]

export const merchantRouterMap = [
  merchantInfoRouter,
  merchantOrderCheckRouter,
  merchantSubAccounRouter,
  merchantTransferRouter,
  merchantSysSetting
]

export const agentRouterMap = [
  merchantManageRouter,
  orderManageRouter,
  agentManageRouter,
  orderStatisticsManageRouter,
  {
    path: '/modifyPassword',
    component: Layout,
    meta: { title: '系统设置', icon: 'menu-system', roles: ['all'] },
    children: [
      {
        path: 'index',
        component: () => import('@/views/common/resetPassword'),
        name: 'modifyPassword',
        meta: { title: '修改登录密码', icon: 'password', noCache: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js